<template>
  <cf-expandable-section
    v-if="order.orderAttributes.canAddPromoCode"
    :auto-expand="autoExpandPromoCodeField"
  >
    <template #title>
      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        Add Promo Code
      </p>
    </template>

    <template #content>
      <div class="cf-grid cf-grid--2-grid-column-left-large cf-grid--align-center cf-grid--gap-16">
        <cf-text-input
          v-model="code"
          type="text"
          label="Promo Code"
          name="code"
          class="cf-clear-margin"
          @keydown.enter="apply"
        />

        <button
          :class="['cf-button cf-button--primary cf-button--md cf-button--auto', { 'cf-button--loading': isApplyingDiscount}]"
          type="button"
          :disabled="!code"
          @click="apply"
        >
          Redeem
        </button>
      </div>
    </template>
  </cf-expandable-section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';
  import errorHandlers from '@/services/error-handlers';

  import CfExpandableSection from '@/view/components/shared/cf-expandable-section/index.vue';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfApplyDiscountCode',

    components: {
      CfExpandableSection,
      CfTextInput
    },

    data() {
      return {
        code: null,
        isApplyingDiscount: false
      };
    },

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('merchant', ['merchant']),

      autoExpandPromoCodeField() {
        return this.merchant.features['show-promo-code-field'];
      }
    },

    methods: {
      async apply() {
        try {
          this.isApplyingDiscount = true;

          await this.$store.dispatch('orders/redeemOffer', {
            promotionCode: this.code
          });

          events.emit('notification', {
            type: 'success',
            message: `Promo code "${this.code}" was applied.`
          });

          this.code = null;
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isApplyingDiscount = false;
        }
      }
    }
  };
</script>
